<template>
  <v-list-item exact link @click="$emit('click')" :to="link ? {name: link} : null">
    <v-list-item-action>
      <v-tooltip right>
        <template v-slot:activator="{on, attrs}">
          <v-icon v-on="on" v-bind="attrs">{{icon}}</v-icon>
        </template>
        <span>{{ title }}</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title class="body-1">{{ title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "MainMenuItem",
  props: {
    icon: String,
    title: String,
    link: String,
  },
};
</script>